module.exports = __webpack_public_path__ + "static/media/n.86e75624.jpg";